module.exports = __webpack_public_path__ + "img/santarosa_background_hero.f58eadbd.png";